export const getConversionsMetrics = () => {
  return {
    allColumns: [
      'conversions-postbacktimestamp',
      'conversions-clickid',
      'reports-externalid',
      'conversions-hiddenrevenue',
      'reports-customevent',
      'conversions-transactionid',
      'conversions-revenue',
      'conversions-cost',
      'conversions-postbackstatus',
      'conversions-useragent',
      'campaigns-id',
      'campaigns-name',
      'landings-id',
      'landings-name',
      'offers-id',
      'offers-name',
      'flows-id',
      'flows-name',
      'reports-country',
      'traffic_sources-id',
      'traffic_sources-name',
      'affiliate_networks-id',
      'affiliate_networks-name',
      'reports-os',
      'reports-osversion',
      'reports-devicetype',
      'reports-devicevendor',
      'reports-devicemodel',
      'reports-browser',
      'reports-browserversion',
      'reports-isp',
      'reports-mobilecarrier',
      'reports-connecttype',
      'reports-ip',
      'reports-referrer',
      'reports-custom1',
      'reports-custom2',
      'reports-custom3',
      'reports-custom4',
      'reports-custom5',
      'reports-custom6',
      'reports-custom7',
      'reports-custom8',
      'reports-custom9',
      'reports-custom10',
      'reports-custom1masked',
      'reports-custom2masked',
      'reports-custom3masked',
      'reports-custom4masked',
      'reports-custom5masked',
      'reports-custom6masked',
      'reports-custom7masked',
      'reports-custom8masked',
      'reports-custom9masked',
      'reports-custom10masked',
    ],
    defaultUnselected: [
      'campaigns-id',
      'reports-customevent',
      'conversions-hiddenrevenue',
      'conversions-transactionid',
      'conversions-revenue',
      'conversions-cost',
      'conversions-postbackstatus',
      'landings-id',
      'landings-name',
      'offers-id',
      'offers-name',
      'flows-id',
      'flows-name',
      'reports-country',
      'traffic_sources-id',
      'traffic_sources-name',
      'affiliate_networks-id',
      'affiliate_networks-name',
      'reports-os',
      'reports-osversion',
      'reports-devicetype',
      'reports-devicevendor',
      'reports-devicemodel',
      'reports-browser',
      'reports-browserversion',
      'reports-isp',
      'reports-mobilecarrier',
      'reports-connecttype',
      'reports-ip',
      'reports-referrer',
      'reports-custom1',
      'reports-custom2',
      'reports-custom3',
      'reports-custom4',
      'reports-custom5',
      'reports-custom6',
      'reports-custom7',
      'reports-custom8',
      'reports-custom9',
      'reports-custom10',
      'reports-custom1masked',
      'reports-custom2masked',
      'reports-custom3masked',
      'reports-custom4masked',
      'reports-custom5masked',
      'reports-custom6masked',
      'reports-custom7masked',
      'reports-custom8masked',
      'reports-custom9masked',
      'reports-custom10masked',
      'conversions-useragent',
    ],
    defaultSelected:[
      'conversions-postbacktimestamp',
      'conversions-clickid'
    ],
    defaultSort: [
      'conversions-postbacktimestamp'
    ],
    order: {
      orderBy: 'conversions-postbacktimestamp',
      orderDir: 'desc',
    },
    weight: {},
    sortExclude:['conversions-useragent']
  } //as Bemob.Metrics
}
